<template lang="pug">

	//- Componente de ferramentas à direita do mapa

	div#toolbox.float-box(:class="{ hidden: !expanded }")
		
		//- Barra vertical com os botões sempre visíveis
		div.toolbox-buttons-bar

			div.float-box-btn-group(v-for="buttonGroup in buttons")
				
				div.float-box-btn(v-for="button in buttonGroup", 
						@click="callAction(button)",
						:title="button.name")

					i(:class="button.iconClass")

		//- Coluna de conteúdo que pode ser oculta
		div.toolbox-view.float-box-view

			div.col-md-12.float-box-title

				h2.pull-left 
					i(v-show="contentTitleIconClass", :class="contentTitleIconClass")
					| {{ contentTitle }}

				i.action-icon.mdi.mdi-window-close.float-box-collapse-icon(@click="collapse()")

			//- Renderizando cada um dos componentes configurados
			component(v-for="comp in viewComponents", 
					:is="comp", 
					:ref="comp.name",
					:key="comp.name",
					v-show="comp.name === currentComponent")

</template>

<script>

import FloatBox from '@/components/FloatBox';

export default {
	name: 'ToolBox',
	extends: FloatBox
};

</script>

<style lang="scss">

@import "../styles/mixins";
@import "../styles/variaveis";

#toolbox {
	right: 0;
	width: $toolbox-view-width;

	&.hidden {
		transform: translateX($toolbox-view-width);
	}

	.toolbox-view {
		@include box-shadow(-1px, -6px, 8px, rgba(0, 0, 0, 0.4)); // TODO extrair
	}

	.toolbox-buttons-bar {
		position: absolute;
		left: -($toolbox-btn-width + $toolbox-btn-margin-right);
		top: 0;
		display: block;
	}
}

</style>



// WEBPACK FOOTER //
// ToolBox.vue?df18d2ae